type LeaveCancelledListener = () => void;

const leaveCancelledListeners = new Set<LeaveCancelledListener>();

// UI reacts to a browser back button click and go back to the page the user stayed on and highlights the tab.
export const subscribeToLeaveCancelled = (listener: LeaveCancelledListener) => {
  leaveCancelledListeners.add(listener);

  return () => {
    leaveCancelledListeners.delete(listener);
  };
};

export const notifyLeaveCancelled = () => {
  leaveCancelledListeners.forEach((listener) => listener());
};
